import { gql } from "@apollo/client"

export const SENIORITY = gql`
    query GetAllSeniorities {
        connection: senioritiesList {
            name
            seniorityId
        }
    }
`;